import { useTranslation } from "react-i18next";
import { AppAccordion } from "@/components/ui";

/**
 * FAQ section — HeroUI Accordion with single-expand behavior.
 * Rosé Pine Dawn luxury aesthetic with large rounded corners.
 * SC-009: Expand/collapse completes within 300ms.
 */
export function FaqSection() {
  const { t } = useTranslation();

  const items = t("landing.faq.items", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];

  return (
    <section id="faq" className="py-32 px-6 bg-surface/50 scroll-mt-24">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-20 space-y-4">
          <h2 className="text-sm font-bold text-accent uppercase tracking-[0.4em]">
            {t("landing.faq.subtitle")}
          </h2>
          <h3 className="text-4xl font-bold">
            {t("landing.faq.heading")}
          </h3>
        </div>
        <AppAccordion className="space-y-4" allowsMultipleExpanded={false}>
          {items.map((faq, i) => (
            <AppAccordion.Item key={i} id={`faq-${i}`} className="bg-background border border-border rounded-3xl overflow-hidden shadow-sm">
              <AppAccordion.Heading>
                  <AppAccordion.Trigger className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-surface transition-colors cursor-pointer">
                  <span className="font-bold text-lg">{faq.question}</span>
                  <AppAccordion.Indicator className="text-success shrink-0 ml-4" />
                </AppAccordion.Trigger>
              </AppAccordion.Heading>
              <AppAccordion.Panel>
                <AppAccordion.Body className="px-8 pb-8">
                  <p className="text-foreground-secondary leading-relaxed">{faq.answer}</p>
                </AppAccordion.Body>
              </AppAccordion.Panel>
            </AppAccordion.Item>
          ))}
        </AppAccordion>
      </div>
    </section>
  );
}
